const BASE = process.env.REACT_APP_API_URL || '/api';

const getToken = () => localStorage.getItem('voxpop_token');

const request = async (method, path, body, options = {}) => {
  const token = getToken();
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
    ...options,
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(data.error || 'Request failed'), { status: res.status, data });
  return data;
};

export const api = {
  get:    (path)        => request('GET', path),
  post:   (path, body)  => request('POST', path, body),
  patch:  (path, body)  => request('PATCH', path, body),
  delete: (path)        => request('DELETE', path),

  // Auth
  register:      (data) => api.post('/auth/register', data),
  login:         (data) => api.post('/auth/login', data),
  me:            ()     => api.get('/auth/me'),
  verifyEmail:   (token)=> api.post('/auth/verify-email', { token }),
  forgotPassword:(email)=> api.post('/auth/forgot-password', { email }),
  resetPassword: (data) => api.post('/auth/reset-password', data),
  updateProfile: (data) => api.patch('/auth/me', data),

  // Trailers
  getTrailers:    (params={}) => api.get(`/trailers?${new URLSearchParams(params)}`),
  getTrailer:     (slug)  => api.get(`/trailers/${slug}`),
  getLeaderboard: ()      => api.get('/trailers/leaderboard'),
  vote:           (data)         => api.post(`/trailers/${data.trailerId}/vote`, { quantity: data.votes }),
  buyTicket:      (id)    => api.post(`/trailers/${id}/ticket`),
  hasVoted:       ()      => api.get('/trailers/user/has-voted'),

  // Wallet
  getWallet:      ()          => api.get('/wallet'),
  fundWalletIntent:(amount)   => api.post('/wallet/fund/intent', { amountCents: amount }),
  confirmFund:     (data)     => api.post('/wallet/fund/confirm', data),

  // User
  getDashboard:   ()          => api.get('/user/dashboard'),
  saveProgress:   (data)      => api.post('/user/watch-progress', data),
  getProgress:    (id)        => api.get(`/user/watch-progress/${id}`),

  // Events
  getEvents:      ()          => api.get('/events'),
  rsvpEvent:      (id)        => api.post(`/events/${id}/rsvp`),

  // Shop
  getProducts:    ()          => api.get('/shop/products'),
  placeOrder:     (data)      => api.post('/shop/order', data),

  // Submissions
  submitFilmmaker:(data)      => api.post('/submissions', data),

  // Admin
  adminGetUsers:         (search) => api.get(`/admin/users${search ? `?search=${search}` : ''}`),
  adminGetUser:          (id)     => api.get(`/admin/users/${id}`),
  adminAdjustWallet:     (id, d)  => api.patch(`/admin/users/${id}/wallet`, d),
  adminSetUserStatus:    (id, d)  => api.patch(`/admin/users/${id}/status`, d),
  adminGetSubmissions:   (status) => api.get(`/submissions${status ? `?status=${status}` : ''}`),
  adminUpdateSubmission: (id, d)  => api.patch(`/submissions/${id}`, d),
  adminCreateTrailer:    (d)      => api.post('/trailers', d),
  adminUpdateTrailer:    (id, d)  => api.patch(`/trailers/${id}`, d),
  adminDeactivateTrailer:(id)     => api.delete(`/trailers/${id}`),
  adminGetAuditLog:      ()       => api.get('/admin/audit-log'),
  adminCreateEvent:      (d)      => api.post('/events', d),
  // Library (gated — requires at least 1 vote)
  getLibrary:     ()          => api.get('/trailers?status=library'),

  // Standings / leaderboard
  getStandings:   ()          => api.get('/trailers/leaderboard'),

  // Contact form submission
  contactSubmit:  (data)      => api.post('/contact', data),
};
